"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));
var _get = _interopRequireDefault(require("lodash/get"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _pick = _interopRequireDefault(require("lodash/pick"));
var _i18n = require("../../../i18n");
var _hooks = require("../hooks");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CreateReportButton = _ref => {
  let {
    accountId,
    disabled,
    beforeSubmit,
    onSubmitComplete,
    options,
    projectId,
    onValidationError,
    onReportSubmit
  } = _ref;
  const {
    T
  } = (0, _i18n.useTranslation)();
  const {
    notifyError
  } = (0, _hooks.useNotifications)();
  const formValues = (0, _pick.default)((0, _react.useContext)(_QuickReportsPanelContext.default), ['reportTitle', 'reportService', 'reportType', 'reportFormat', 'reportComponents', 'saveOptions']);
  const validateReportItemCount = (0, _hooks.useValidateItemCount)();
  const handleReportCreation = () => {
    onReportSubmit();
    (0, _hooks.getHandleReportCreation)({
      accountId,
      formValues: formatFormValues(formValues),
      projectId,
      options,
      beforeSubmit,
      onSubmitComplete,
      onValidationError,
      onValidateReport: validateReportItemCount,
      onError: () => notifyError({
        i18nKey: 'notifications.reportFailed',
        values: {
          reportTitle: formValues.reportTitle
        }
      })
    });
  };
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    "data-testid": "createReportButton",
    variant: _alloyReactButton.default.VARIANTS.PRIMARY,
    disabled: disabled,
    onClick: handleReportCreation
  }, T.translate('button.runReport'));
};
const formatFormValues = formValues => {
  const componentsCopy = (0, _get.default)(formValues, 'reportComponents', null);
  if (componentsCopy) {
    const requestComponents = (0, _mapValues.default)(componentsCopy, component => (0, _omit.default)(component, ['readOnly', 'parent']));
    const formattedFormValues = {
      ...formValues,
      reportComponents: requestComponents
    };
    return formattedFormValues;
  } else {
    return formValues;
  }
};
const StyledButton = (0, _styledComponents.default)(_alloyReactButton.default)`
  width: 100%;
`;
CreateReportButton.defaultProps = {
  formValues: {},
  disabled: false,
  beforeSubmit: () => {},
  onSubmitComplete: () => {},
  onValidationError: () => {},
  onReportSubmit: () => {}
};
CreateReportButton.propTypes = {
  accountId: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  beforeSubmit: _propTypes.default.func,
  onSubmitComplete: _propTypes.default.func,
  options: _propTypes.default.object,
  projectId: _propTypes.default.string,
  onValidationError: _propTypes.default.func,
  onReportSubmit: _propTypes.default.func
};
var _default = exports.default = CreateReportButton;